import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { applyActionCode } from "firebase/auth";
import { auth } from "./firebase";

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const verifyEmail = async () => {
      const oobCode = searchParams.get("oobCode");

      if (!oobCode) {
        setStatus("error");
        setMessage("Invalid verification link.");
        return;
      }

      try {
        await applyActionCode(auth, oobCode);
        setStatus("success");
        setMessage("Your email has been verified successfully!");
        setTimeout(() => navigate("/login"), 3000);
      } catch (error) {
        console.error(error);
        setStatus("error");
        if (error.code === "auth/expired-action-code") {
          setMessage("This verification link has expired.");
        } else if (error.code === "auth/invalid-action-code") {
          setMessage("Invalid verification link.");
        } else {
          setMessage("Something went wrong. Please try again.");
        }
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <div style={styles.container}>
      <div style={styles.card}>

        {/* Top accent bar */}
        <div style={styles.accentBar} />

        <div style={styles.body}>
          <div style={styles.iconWrap}>
            {status === "loading" && <i className="fa-solid fa-spinner fa-spin" style={styles.icon} />}
            {status === "success" && <i className="fa-solid fa-circle-check" style={{ ...styles.icon, color: "#0A9396" }} />}
            {status === "error"   && <i className="fa-solid fa-circle-xmark" style={{ ...styles.icon, color: "#EF4444" }} />}
          </div>

          <h2 style={styles.title}>Email Verification</h2>

          {status === "loading" && (
            <p style={styles.text}>Verifying your email address…</p>
          )}

          {status === "success" && (
            <>
              <p style={{ ...styles.text, color: "#0A9396", fontWeight: "600" }}>
                {message}
              </p>
              <p style={{ ...styles.text, fontSize: "13px", color: "#6B7280" }}>
                You will be redirected to login shortly.
              </p>
              <button
                style={styles.button}
                onClick={() => navigate("/login")}
                onMouseOver={e => (e.currentTarget.style.background = "#087879")}
                onMouseOut={e => (e.currentTarget.style.background = "#0A9396")}
              >
                Continue to Login
              </button>
            </>
          )}

          {status === "error" && (
            <p style={{ ...styles.text, color: "#EF4444", fontWeight: "600" }}>
              {message}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "var(--off-white)",
    padding: "24px",
  },
  card: {
    background: "#fff",
    borderRadius: "18px",
    boxShadow: "0 8px 28px rgba(0,0,0,0.10)",
    width: "100%",
    maxWidth: "400px",
    overflow: "hidden",
    border: "1px solid var(--gray-200)",
  },
  accentBar: {
    height: "4px",
    background: "linear-gradient(90deg, #0A9396, #087879)",
  },
  body: {
    padding: "40px 36px",
    textAlign: "center",
  },
  iconWrap: {
    marginBottom: "16px",
  },
  icon: {
    fontSize: "40px",
    lineHeight: "1",
  },
  title: {
    fontSize: "22px",
    fontWeight: "800",
    color: "var(--gray-900)",
    margin: "0 0 14px",
    letterSpacing: "-0.02em",
  },
  text: {
    fontSize: "15px",
    color: "var(--gray-500)",
    lineHeight: "1.65",
    margin: "0 0 18px",
  },
  button: {
    marginTop: "8px",
    width: "100%",
    padding: "13px",
    border: "none",
    background: "#0A9396",
    color: "#fff",
    borderRadius: "8px",
    fontSize: "15px",
    fontWeight: "700",
    fontFamily: "inherit",
    cursor: "pointer",
    transition: "background 0.24s ease",
    boxShadow: "0 2px 10px rgba(10,147,150,0.38)",
  },
};
